/**
 * Upload size constants
 * Centralized client-side upload size caps (MB).
 *
 * These MIRROR the backend caps and exist purely as UX polish: the server is
 * the source of truth (utils/file_helpers.MAX_IMAGE_UPLOAD_MB and the 50MB
 * floor-plan cap). Pre-checking here lets us reject an oversized file with an
 * instant toast instead of shipping it over the wire only to get a 400/413
 * back. Keep these in lockstep with the backend when either side changes.
 */

// Per-file cap for image uploads (property photos, room/item images, etc.).
export const MAX_IMAGE_UPLOAD_MB = 25;

// Per-file cap for floor-plan uploads (larger — plans are high-resolution).
export const MAX_FLOOR_PLAN_UPLOAD_MB = 50;
